import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "aria-hidden": "true" }
const _hoisted_2 = { class: "pr-x2 mb-5" }
const _hoisted_3 = { class: "w-75" }
const _hoisted_4 = { class: "w-full" }

import CheckoutSkeletonLine from '@/b2c/shared/checkout/ui/CheckoutSkeletonLine.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutItemSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CheckoutSkeletonLine, {
          dark: true,
          class: "o-aspect-ratio-4/3 xs:h-auto"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CheckoutSkeletonLine, {
        dark: true,
        class: "mb-5 xs:h-12"
      }),
      _createVNode(CheckoutSkeletonLine, {
        dark: true,
        class: "mb-5 xs:h-12"
      }),
      _createVNode(CheckoutSkeletonLine, {
        dark: true,
        class: "xs:h-12"
      })
    ])
  ]))
}
}

})